import { render } from "./CountdownTimer.vue?vue&type=template&id=5ef7b379&scoped=true"
import script from "./CountdownTimer.vue?vue&type=script&lang=js"
export * from "./CountdownTimer.vue?vue&type=script&lang=js"

import "./CountdownTimer.vue?vue&type=style&index=0&id=5ef7b379&scoped=true&lang=css"

import exportComponent from "/home/peter/new-demo-tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ef7b379"]])

export default __exports__